(() => {
  const configElement = document.querySelector('[data-collection-friendly-config]');

  if (!configElement) return;

  let config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('Collection friendly labels were not applied because the configuration is invalid.', error);
    return;
  }

  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  const setText = (element, value) => {
    if (element && value && element.textContent.trim() !== value) {
      element.textContent = value;
    }
  };

  const setLeadingText = (element, value) => {
    if (!element || !value) return;

    const textNode = Array.from(element.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
    const nextValue = `${value} `;

    if (textNode) {
      if (textNode.nodeValue !== nextValue) textNode.nodeValue = nextValue;
    } else {
      element.insertBefore(document.createTextNode(nextValue), element.firstChild);
    }
  };

  const getFilterKey = (paramName) => {
    if (!paramName) return '';
    if (paramName === 'filter.v.availability') return 'availability';
    if (paramName.startsWith('filter.v.price')) return 'price';
    if (paramName === 'filter.p.product_type' || paramName === 'filter.p.category' || paramName === 'filter.p.t.category') return 'category';
    if (paramName.includes('.skill_level')) return 'skill_level';
    if (paramName.includes('.project_type')) return 'project_type';
    if (paramName.includes('.estimated_time')) return 'estimated_time';
    if (paramName.includes('.video_tutorial')) return 'video_tutorial';
    if (paramName.includes('.gift_ready')) return 'gift_ready';
    if (paramName.includes('.storage_capacity')) return 'storage_capacity';
    if (paramName.includes('.yarn_feed_holes')) return 'yarn_feed_holes';
    return '';
  };

  const getValueLabel = (input, filterKey) => {
    const value = normalize(input.value);

    if (filterKey === 'category' && config.categoryValueLabels) {
      const categoryLabel = config.categoryValueLabels[input.value];
      if (categoryLabel) return categoryLabel;
    }

    if (filterKey === 'availability') {
      if (value === '1') return config.values.in_stock;
      if (value === '0') return config.values.out_of_stock;
    }

    return config.values[value] || '';
  };

  const applyFriendlyFilters = () => {
    if (!config.filtersEnabled) return;

    document.querySelectorAll('#CollectionFiltersForm input[name^="filter."]').forEach((input) => {
      const filterKey = getFilterKey(input.name);
      const filterLabel = config.labels[filterKey];
      const facet = input.closest('.js-filter');

      if (filterLabel && facet) {
        facet.querySelectorAll('.facets__text').forEach((element) => setText(element, filterLabel));
        facet.querySelectorAll('.sidebarBlock-slide__content-close').forEach((element) => setLeadingText(element, filterLabel));
      }

      const valueLabel = getValueLabel(input, filterKey);
      if (!valueLabel) return;

      const optionLabel = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!optionLabel) return;

      const visibleText = optionLabel.querySelector('.text, .visually-hidden');
      if (visibleText) {
        setText(visibleText, valueLabel);
      } else {
        setLeadingText(optionLabel, valueLabel);
      }

      if (optionLabel.getAttribute('title') && optionLabel.getAttribute('title') !== valueLabel) {
        optionLabel.setAttribute('title', valueLabel);
      }
    });

    document.querySelectorAll('.active-facets__button .text').forEach((element) => {
      const mapped = config.values[normalize(element.textContent)];
      if (mapped) setText(element, mapped);
    });

  };

  const stripInternalCode = (label, sku) => {
    let result = String(label || '').trim();

    if (sku) {
      result = result.replace(new RegExp(sku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig'), '');
    }

    result = result
      .replace(/^[-–—|/:\s]+|[-–—|/:\s]+$/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    return result;
  };

  const applyFriendlyVariants = () => {
    if (!config.variantsEnabled) return;

    document.querySelectorAll('.product-item[data-json-product]').forEach((card) => {
      let product;

      try {
        product = JSON.parse(card.dataset.jsonProduct);
      } catch (_error) {
        return;
      }

      const variants = Array.isArray(product.variants) ? product.variants : [];

      card.querySelectorAll('.swatch-label[data-variant-id]').forEach((label, index) => {
        const variant = variants.find((item) => String(item.id) === String(label.dataset.variantId));
        const originalLabel = label.dataset.customerOriginalLabel || label.getAttribute('title') || label.dataset.value || '';

        if (!label.dataset.customerOriginalLabel) label.dataset.customerOriginalLabel = originalLabel;

        let friendlyLabel = stripInternalCode(originalLabel, variant && variant.sku);

        if (!friendlyLabel || friendlyLabel === '-' || friendlyLabel === '/') {
          friendlyLabel = config.optionFallback.replace('__NUMBER__', String(index + 1));
        }

        const textNodes = Array.from(label.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
        const textNode = textNodes.find((node) => node.nodeValue.trim()) || textNodes[textNodes.length - 1];
        const nextText = `\n                                    ${friendlyLabel}\n`;

        if (textNode && textNode.nodeValue !== nextText) textNode.nodeValue = nextText;
        if (label.getAttribute('title') !== friendlyLabel) label.setAttribute('title', friendlyLabel);
      });
    });
  };

  let updateQueued = false;

  const applyEnhancements = () => {
    updateQueued = false;
    applyFriendlyFilters();
    applyFriendlyVariants();
  };

  const queueEnhancements = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(applyEnhancements);
  };

  queueEnhancements();

  const observer = new MutationObserver(queueEnhancements);
  observer.observe(document.body, { childList: true, subtree: true });
})();
